import { Horizontal } from "gls";
import { colours } from "styling/colours";
import { style } from "typestyle";

type NoTaskProps = {
  title?: string;
};

export const EmptyListMessage = ({ title }: NoTaskProps) => {
  return (
    <Horizontal horizontalAlign="center" className={noTaskStyle}>
      {title && <p dangerouslySetInnerHTML={{ __html: title }} />}
    </Horizontal>
  );
};

const noTaskStyle = style({
  padding: "1.5em 0",
  borderRadius: "6px",
  color: colours.primaryText,
  border: `1px solid ${colours.tertiaryText}`,
  $nest: {
    "p": {
      margin: "0"
    }
  }
});
